document.addEventListener('DOMContentLoaded',()=>{
  const root=document.querySelector('[data-product-root]');
  if(!root)return;
  const select=root.querySelector('[name="id"]');
  const variants=JSON.parse(root.querySelector('[data-product-variants]').textContent);
  const image=root.querySelector('#ProductMainImage');
  const dialog=root.querySelector('[data-zoom-dialog]');
  const zoomImage=root.querySelector('[data-zoom-image]');
  const showImage=(src,alt)=>{if(!image)return;image.src=src;image.removeAttribute('srcset');if(alt)image.alt=alt;if(zoomImage){zoomImage.src=src;zoomImage.alt=image.alt;}};
  root.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>showImage(button.dataset.gallerySrc,button.dataset.galleryAlt)));
  root.querySelector('[data-zoom-open]')?.addEventListener('click',()=>{if(image&&dialog&&zoomImage){zoomImage.src=image.currentSrc||image.src;zoomImage.alt=image.alt;dialog.showModal();}});
  root.querySelector('[data-zoom-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  select?.addEventListener('change',()=>{
    const variant=variants.find(v=>String(v.id)===select.value);if(!variant)return;
    root.querySelectorAll('[data-price],[data-mobile-price]').forEach(el=>el.textContent=variant.price);
    root.querySelector('[data-mobile-variant]').textContent=variant.title==='Default Title'?'':variant.title;
    root.querySelectorAll('[data-add]').forEach(button=>{button.disabled=!variant.available;button.textContent=variant.available?'Add to Cart':'Sold out';});
    root.querySelector('[data-availability]').textContent=variant.available?'Available to order':'Sold out';
    if(variant.image)showImage(variant.image);
    const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
  });
  const label=root.querySelector('[data-mobile-variant]');if(label?.textContent==='Default Title')label.textContent='';
});
